<template>
  <transition name="modal-fade">
    <div class="modal-overlay">
      <div
        :class="[
          'modal-body-container',
          {
            modalPage: view.showModalAsPage,
          },
        ]"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="disable-two-factor-authentication"
      >
        <widget-breadcrumb-nav
          modalName="disable-two-factor-authentication"
          :isModal="true"
          v-if="view.showModalAsPage"
          @onNavClick="close"
        />
        <button
          type="button"
          class="btn-close"
          @click="close"
          v-if="!view.showModalAsPage"
          aria-label="Close modal"
        >
          &times;
        </button>
        <div class="modal-content-wrapper">
          <div>
            <h4>
              {{ $t("emailAccounts.emailList.disable2FA") }}
            </h4>
            <p class="color-grey">
              {{ $t("emailAccounts.disable2FA.description", [user.email]) }}
            </p>
            <div class="button-wrapper">
              <button ref="button" class="button confirmBtn" @click="disable2FA">
                {{ $t("emailAccounts.manageAdminRights.confirm") }}
              </button>
              <button class="button button__line-blue cancelBtn" @click="close">
                {{ $t(`emailAccounts.manageAdminRights.cancel`) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getDomainName } from "@/helpers";
import emailService from "@/services/email/email.service";
import { mapGetters } from "vuex";
export default {
  name: "Disable2FA",
  props: {
    user: Object,
    view: Object,
  },
  computed: {
    ...mapGetters(["partnerId"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    disable2FA() {
      return emailService
        .updateConfig({
          accountId: this.user.id,
          accountConfig: {
            unsetFlags: ["TWO_FA_ENABLED"],
          },
        })
        .then(this.onSuccess)
        .catch(this.onError);
    },
    onSuccess(data) {
      if (data) {
        this.close();
        this.$parent.getEmailList();
        const message = this.$t(`emailAccounts.disable2FA.successMessage`, [this.user.email]);
        this.showToast(message, {
          type: "success",
          modalName: "disable-two-factor-authentication",
        });
        const eventObj = {
          eventName: "2fa_disable_admin",
          partner_id: this.partnerId,
        };
        this.medusaEvents.send(
          this.medusaEvents.createEventObj(eventObj, getDomainName(), "flock_order")
        );
      }
    },
    onError(response) {
      if (response && response.data && response.data.desc) {
        this.close();
        this.showToast(response.data.desc, {
          type: "error",
          modalName: "disable-two-factor-authentication",
        });
      }
    },
  },
  mounted() {
    if (this.$refs.button) {
      this.$refs.button.focus();
    }
  },
};
</script>
